import React from 'react';
import { Button, CUIText, Dialog, DialogFooterType } from '@dotcom/crown-ui';
import { useTranslation } from 'react-i18next';
import { useAppContext } from '../../context/app-context';
import styles from './redirect-dialog.module.scss';

export const RedirectDialog = () => {
  const { appState } = useAppContext();
  const { redirectUrl, isRedirectDialogOpen } = appState;
  const { t } = useTranslation();

  const handleCloseDialog = () => {
    window.location.href = redirectUrl;
  };
  return (
    <Dialog
      closeButtonId="redirect-dialog-close-button"
      isOpen={isRedirectDialogOpen}
      footerType={DialogFooterType.Passive}
      onClose={() => handleCloseDialog()}
      titleDisabled
    >
      <div className={styles['dialog-body']}>
        <CUIText as="span">{t('redirectModal.modalText')}</CUIText>
        <br />
        <Button variant="secondary" onClick={handleCloseDialog}>
          {redirectUrl}
        </Button>
      </div>
    </Dialog>
  );
};
